import React from "react";
import { CardImg } from "reactstrap";
import { downloadS3File } from "services/services.general";
import JSZip from "jszip";
import styled from "styled-components";
import noImgAvailable from "../../assets/img/noimgavail.png";
import { isImage, isVideo } from "./constants";

const StyledCardImg = styled(CardImg)`
  width: 100%;
  height: 250px;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 250px;
`;

export const renderAttachment = (row, setImages, toggleCarousel) => {
  if (row.attachments && row.attachments.length > 0 && row.attachments[0]) {
    const file = row.attachments[0];

    if (isImage(file.split(".").pop().toLowerCase())) {
      return (
        <StyledCardImg
          src={file}
          alt="Event"
          onClick={() => {
            toggleCarousel();
            setImages(row.attachments);
          }}
        />
      );
    }

    if (isVideo(file.split(".").pop().toLowerCase())) {
      return (
        <StyledVideo
          controls
          onClick={() => {
            toggleCarousel();
            setImages(row.attachments);
          }}
        >
          <source
            src={`${file}?v=1`}
            type="video/mp4"
          />
        </StyledVideo>
      );
    }
  }

  // Fallback image
  return (
    <StyledCardImg
      src={noImgAvailable}
      alt="Event"
    />
  );
};

export const handleDownloadClick = async (
  xlsxLinks,
  attachments,
  title,
  id,
  setIsDownloadInProgress
) => {
  const files = attachments ? [...xlsxLinks, ...attachments] : xlsxLinks;

  const zip = new JSZip();

  // eslint-disable-next-line no-restricted-syntax
  for (const file of files) {
    const parsedUrl = new URL(file);
    const rawFilePath = parsedUrl.pathname.slice(1);
    const fileName = parsedUrl.pathname.split("/").pop();
    const path = rawFilePath.split("/")[0];

    const decodedFileName = decodeURIComponent(fileName);

    const filePath = `${path}/${decodedFileName}`;

    try {
      const data = downloadS3File(filePath);
      zip.file(decodedFileName, data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error downloading ${decodedFileName}:`, error);
    }
  }

  const content = await zip.generateAsync({ type: "blob" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(content);
  link.download = `${title}.zip`;
  link.click();

  setIsDownloadInProgress((prev) => ({
    ...prev,
    [id]: false,
  }));
};

export const validate = (
  form,
  dateImplemented,
  selectedAgency,
  selectedProject,
  selectedPrincipal,
  uploadedExcel,
  uploadedFiles
) => {
  if (!form.title) {
    return "Event title cannot be empty";
  }

  if (!form.venue) {
    return "Venue cannot be empty";
  }

  if (!dateImplemented) {
    return "Date cannot be empty";
  }

  if (!form.numberOfBeneficiary) {
    return "No. of Beneficiary cannot be empty";
  }

  if (!form.costPerBeneficiary) {
    return "Cost per Beneficiary cannot be empty";
  }

  if (!selectedAgency) {
    return "Agency cannot be empty";
  }

  if (!selectedProject) {
    return "Program cannot be empty";
  }

  if (!selectedPrincipal) {
    return "Principal cannot be empty";
  }

  if (uploadedExcel.length === 0) {
    return "List of Beneficiaries cannot be empty";
  }

  if (!form.fbLinks) {
    return "Facebook Link cannot be empty";
  }

  if (uploadedFiles.length === 0) {
    return "Photos & Videos cannot be empty";
  }

  return true;
};
